<template>
  <div class="payin-toolbar-wrapper">
    <div class="left-area"
         :class="{disabled: bettingLocked}">
      <div class="stake-input"
           @click="setTotalPaymentFocus"
           v-if="config.totalStake">
        <label class="input-label">
          {{'general_total_stake' | translate}}
        </label>
        <input id="stake"
               ref="totalPayment"
               class="input no-spinner"
               @blur="changeTotalStake"
               @keyup.enter="changeTotalStake"
               :value="totalPayment.toFixed(2)"
               inputmode="decimal"
               :type="mobile ? 'text' : 'number'"
               :readonly="mobile"/>
        <i class="icon icon-backspace-a" @click="clearStake($event)"></i>
      </div>
      <div class="possible-winning"
           v-if="config.winnings">
        <label class="input-label winnings">
          {{'general_possible_winning' | translate}}
        </label>
        <input id="posible-winning"
               disabled
               class="input no-spinner"
               data-layout="numeric"
               inputmode="numeric"
               :value="possibleWinnigs"
               type="number" />
      </div>
      <div class="future-bets-input"
           v-if="config.futureBets">
        <label class="input-label"
               for="future-rounds">
          {{'general_future_bet' | translate}}
        </label>
        <input id="future-rounds"
               class="input no-spinner"
               :class="{disabled: totalStakeDisabled}"
               :disabled="totalStakeDisabled"
               data-layout="numeric"
               inputmode="numeric"
               @keyup.enter="changeFutureBets"
               @blur="changeFutureBets"
               :value="futureBets"
               type="number" />
      </div>
    </div>
    <div class="right-area">
      <button class="button add-button"
              :class="{disabled: !bettingEnabled || !actionsEnabled || bettingLocked}"
              :disabled="!bettingEnabled || !actionsEnabled || bettingLocked"
              v-if="config.addBet"
              @click="addBetToBetslip">
        {{addLabel | translate}}
      </button>
      <button class="button add-button mobile"
              :class="{disabled: !bettingEnabled || !actionsEnabled || bettingLocked}"
              :disabled="!bettingEnabled || !actionsEnabled || bettingLocked"
              v-if="config.addBet"
              @click="addBetToBetslip">
        <i class="icon icon-plus"></i>
      </button>
      <button class="button login-button important"
              v-if="!player.loggedIn"
              @click="login()">
        {{'general_sign_in' | translate}}
      </button>
      <button class="button payin-button important"
              :class="{disabled: payinDisabled}"
              :disabled="payinDisabled"
              v-if="player.loggedIn"
              @click="payinTicket">
        {{'general_pay_in' | translate}} {{config.addBet ? betsLength : ''}}
      </button>
      <button class="button betslip-button"
              :class="{active: ticket.bets.length && !showBetslip && !quickPayin}"
              @click="toggleBetslip()">
        <div class="items-indicator" :class="{active: ticket.bets.length && !showBetslip && !quickPayin}">
          {{ticket.bets.length}}
        </div>
        <i class="icon"
           :class="betslipIcon"></i>
      </button>
      <div class="betslip-component"
           v-show="showBetslip">
        <div class="betslip-header">
          <div class="header-item"
               v-for="(tab, key) in ticketWrapperTabs"
               :key="key"
               @click="selectTab(key)"
               :disabled="tab.disabled"
               :class="{active: key === selectedTicketTab, disabled: tab.disabled}">
            {{ tab.name | translate }}
            <BetslipMetaInfo v-if="tab.indicator && ticket.bets.length"></BetslipMetaInfo>
          </div>
        </div>
        <div class="betslip-content">
          <ExpandedBetslip v-if="selectedTicketTab === 0" :bettingLocked="bettingLocked"/>
          <LastTickets v-if="selectedTicketTab === 1" :tickets="lastTicketsData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/utility/eventBus';
import BetslipMetaInfo from './BetslipMetaInfo';
import LastTickets from '../LastTickets/LastTicketsWrapper';
import ExpandedBetslip from './Expanded';

export default {
  name: 'PayinToolbar',
  components: {
    BetslipMetaInfo,
    LastTickets,
    ExpandedBetslip,
  },
  props: {
    bettingLocked: {
      type: Boolean,
      default: false,
    },
    bettingDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobile: window.innerWidth <= 960,
      quickPayin: false,
      selectedTicketTab: 0,
      ticketWrapperTabs: [
        {
          name: 'general_betslip',
          indicator: true,
        },
        {
          name: 'general_active_tickets',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'meta',
      'betslipConfig',
      'showBetslip',
      'bet',
      'betsModel',
      'ticket',
      'rules',
      'player',
      'bettingEnabled',
      'payinForbidden',
      'ticketUnpayable',
      'editMode',
      'expandTicketHistory',
      'lastTicketsData',
      'totalStake',
      'futureBets',
      'translations',
      'totalPayment',
      'minPayment',
    ]),
    betExist() {
      return (this.bet.id && this.bet.outcomes.length)
        || (this.bet.id === 0 && this.bet.outcomes.length >= 6);
    },
    betsLength() {
      const len = this.ticket.bets.length;
      return len && !this.quickPayin ? `(${len})` : '';
    },
    addLabel() {
      return this.editMode
        ? 'general_update_bet'
        : 'general_add_bet';
    },
    actionsEnabled() {
      return this.bet.outcomes.length > 0
        || this.betsModel.items.length > 0;
    },
    totalStakeDisabled() {
      return !this.ticket.bets.length;
    },
    betslipIcon() {
      return !this.showBetslip ? 'icon-betslip' : 'icon-arrow-down-d';
    },
    config() {
      return this.betslipConfig;
    },
    possibleWinnigs() {
      return this.bet && this.bet.odd ? (this.bet.odd * this.totalPayment).toFixed(2) : 0;
    },
    payinDisabled() {
      return this.payinForbidden || this.ticketUnpayable
        || (!this.bettingEnabled && !this.ticket.bets.length)
        || (!this.ticket.bets.length && !this.betExist)
        || this.bettingLocked
        || this.bettingDisabled;
    },
  },
  methods: {
    ...mapActions([
      'setTotalStake',
      'setFutureBets',
      'showHideBetslip',
      'addDataToBetslip',
      'resetBet',
      'resetBets',
      'resetSelection',
      'payin',
      'checkPayin',
      'selectAllColors',
      'resetSelectedBet',
      'updateNotifications',
      'toggleTicketHistory',
      'setTotalPayment',
    ]),
    setTotalPaymentFocus() {
      if (this.bettingLocked) return;
      if (!this.mobile) this.$refs.totalPayment.select();
      eventBus.$emit('openStakeBox');
    },
    selectTab(key) {
      if (!this.lastTicketsData.length) this.selectedTicketTab = 0;
      if (this.bettingLocked || !this.player.id) return;
      this.selectedTicketTab = key;
    },
    toggleBetslip() {
      this.showHideBetslip();
      eventBus.$emit('toggleBetslip');
    },
    showHideTicketHistory() {
      this.toggleTicketHistory();
    },
    changeTotalStake(e) {
      this.totalStakeActive = false;
      const stake = Number(e.target.value).toFixed(2);
      if (stake !== this.totalPayment) {
        this.setTotalPayment(stake);
      }

      if (this.payinForbidden) {
        const msg = this.translations.general_max_bet_amount_rule.supplant({
          value: this.rules.maxBetAmount.value,
        });
        this.updateNotifications({
          status: 'error',
          message: msg,
        });
      }
    },
    changeFutureBets(e) {
      const futureBets = Number(e.target.value);
      this.setFutureBets(futureBets);
    },
    addBetToBetslip() {
      this.quickPayin = false;
      const data = this.betsModel.items.length ? this.betsModel : this.bet;
      if (!this.player.loggedIn) {
        this.updateNotifications({
          status: 'error',
          message: 'general_player_login',
          duration: 7000,
        });
      }
      if (!this.bettingEnabled) {
        this.updateNotifications({
          status: 'info',
          message: this.rules.minBallSelection.message,
        });
        return;
      }
      if (!this.maxBetValid() && !this.editMode) {
        const msg = this.translations.general_max_bet_count_rule.supplant({
          value: this.rules.maxBetNumber.value,
        });
        this.updateNotifications({
          status: 'error',
          message: msg,
        });
        return;
      }
      eventBus.$emit('addBet');
      this.addDataToBetslip(data);
      this.checkPayin();
      this.clearSelection();
      this.selectTab(0);
    },
    maxBetValid() {
      const { maxBetNumber } = this.rules;
      const betsLen = this.ticket.bets.length;
      return betsLen < maxBetNumber.value;
    },
    clearSelection() {
      this.resetBet();
      this.resetBets();
      this.resetSelection();
      this.resetSelectedBet();
      this.selectAllColors(false);
    },
    login() {
      eventBus.$emit('loginRequired');
    },
    payinTicket() {
      eventBus.$emit('payin');
      if ((this.bet.id || this.bet.id === 0) && !this.ticket.bets.length) {
        this.quickPayin = true;
        eventBus.$emit('quickPayin', this.bet);
        return;
      }
      this.payin(this.ticket);
    },
    clearStake(e) {
      this.setTotalPayment(this.minPayment);
      e.preventDefault();
      e.stopPropagation();
    },
  },
  created() {
    if (!this.player.id) {
      this.ticketWrapperTabs[1].disabled = true;
    }
    eventBus.$on('clearBetslip', () => {
      if (this.showBetslip) {
        this.toggleBetslip();
      }
    });
    eventBus.$on('rebet', () => {
      this.selectTab(0);
    });
  },
  watch: {
    editMode(edit) {
      if (!edit) this.clearSelection();
    },
    betExist(value) {
      if (value && !this.ticket.bets.length) {
        this.setTotalPayment(this.bet.minPayment);
      }
    },
    player(value) {
      if (value.id) this.ticketWrapperTabs[1].disabled = false;
    },
    lastTicketsData(value) {
      if (!value.length) this.selectTab(0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .payin-toolbar-wrapper {
    width: 100%;
    float: left;
    height: 60px;
    background-color: var(--betslip-bg, var(--card-bg));
    border-radius: 2px;
    padding: 10px;
    position: relative;
    box-shadow: 0 20px 40px 0 var(--box-shadow);

    .stake-box {
      bottom: 100px;
      left: 0;
      width: 300px;
    }

    .button {
      &.important {
        width: 114px;
      }
    }

    .betslip-button {
      cursor: pointer;
      width: 50px;

      &.active {
        background-color: var(--accent-bg, var(--brand-bg));
        color: var(--accent-text, var(--brand-text-color));
      }
    }

    .left-area {
      float: left;
      height: 100%;
      width: 30%;
      display: flex;
      justify-content: flex-start;

      &.disabled {
        opacity: .4;
      }

      .stake-input {
        width: 100%;
        background-color: var(--input-bg);
        border-radius: 2px;
        .icon {
          position: absolute;
          right: 14px;
          top: 11px;
          cursor: pointer;
        }

        .input {
          border-radius: 2px;
          background-color: var(--input-bg);
          border: none;
          outline: 0;
          position: relative;
          text-indent: 8px;
          padding: 21px 0 0 0;
          height: 100%;
          font-size: 14px;
          color: var(--text-primary-1);
          width: 80%;

          &.disabled {
            opacity: 0.5;
          }
        }
      }

      input {
        font-family: 'Roboto', sans-serif;
      }

      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      .stake-input,
      .future-bets-input,
      .possible-winning {
        float: left;
        height: 100%;
        margin-right: 10px;
        position: relative;
      }

      .input-label {
        position: absolute;
        left: 8px;
        top: 4px;
        z-index: 100;
        font-size: 12px;
        color: var(--text-primary-2);
      }
    }
    .input-label {
      position: absolute;
      left: 8px;
      top: 4px;
      z-index: 100;
      font-size: 12px;
      color: var(--text-primary-2);
    }
  }

  .right-area {
    float: right;
    height: 100%;
    width: 70%;
    display: flex;
    justify-content: flex-end;

    .add-button {
      width: 50px;
      background-color: var(--add-bet-button-mobile-bg, var(--brand-bg));
      color: var(--add-bet-button-mobile-text-color, var(--brand-text-color));
    }

    .payin-button,
    .login-button {
      width: 120px;
      background-color: var(--payin-button-bg, var(--brand-bg));
      color: var(--payin-button-text-color, var(--brand-text-color));
    }

    .mobile {
      display: none;
    }

    .betslip-button,
    .payin-button,
    .login-button,
    .add-button {
      cursor: pointer;
      float: left;
      margin-left: 8px;
      transition: all .5s ease;

      &.disabled {
        opacity: .4;
      }
    }

    .payin-button,
    .add-button {
      font-size: 14px;
    }

    .betslip-button {
      .items-indicator {
        position: absolute;
        background-color: transparent;
        color: transparent;
        right: 17px;
        top: 11px;
        border-radius: 100%;
        font-weight: 700;
        font-size: 12px;
        width: 18px;
        height: 18px;
        line-height: 18px;

        &.active {
          background-color: var(--accent-bg, var(--brand-bg));
          color: var(--accent-text, var(--text-primary-1));
          transition: all .5s ease;
        }
      }
    }
  }

  .betslip-component {
    position: absolute;
    bottom: 100px;
    width: 300px;
    right: 0;
    background-color: var(--card-bg);
    box-shadow: 0 20px 40px 0 var(--box-shadow);
  }

  .icon {
    padding: 0;
    font-size: 1em;
    vertical-align: middle;
  }

  @media (min-width: 306px) and (max-width: 660px) {
    .payin-toolbar-wrapper {
      .left-area {
        .input-label {
          left: 8px;
          top: 5px;
          font-size: 10px;
          width: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .future-bets-input {
          display: none;
        }
      }
      .right-area {
        .add-button {
          display: none;
        }

        .button {
          &.mobile {
            display: block;

            .icon {
              font-size: 1.5em;
            }
          }
        }

        .betslip-component {
          width: 100%;
          display: none;
        }
      }
    }
  }

  @media (min-width: 661px) {
    .payin-toolbar-wrapper {
      .left-area {
        .input {
          font-size: 12px;
          padding: 15px 0 0 0;
        }

        .future-bets-input {
          display: none;
        }
      }
      .right-area {
        .button {
          font-size: 12px;
        }
        .add-button {
          width: 120px;
        }
        .betslip-component {
          height: 264px;
          bottom: 175px;
          z-index: 100;

          .betslip-header {
            float: left;
            width: 100%;
            height: 40px;

            .header-item {
              position: relative;
              float: left;
              width: 50%;
              height: 100%;
              padding: 10px;
              text-align: center;
              cursor: pointer;
              background-color: var(--card-bg);
              color: var(--text-primary-1);
              border-bottom: 2px solid var(--tab-border-color);

              &.active {
                border-bottom: 2px solid var(--accent-bg, var(--brand-bg));
                color: var(--accent-bg, var(--brand-bg));
              }

              &.disabled, &:disabled {
                background-color: var(--tab-pressed-bg);
                color: var(--text-primary-3);
              }
            }
          }
          .betslip-content {
            .expanded-wrapper {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>
